import React from 'react';
import { ClaimScoreActionOutputV2View, type ActionOutputV2Payload } from '@circuitry-ai/doc-ui';

type Props = {
    payload: ActionOutputV2Payload;
    timestamp?: string;
    agentName?: string;
};

export const AdjustmentCostValidationView: React.FC<Props> = ({ payload, timestamp, agentName }) => (
    <div className="w-full min-w-0">
        <ClaimScoreActionOutputV2View
            data={payload}
            timestamp={timestamp}
            agentName={agentName}
            hideSectionHeaders
        />
    </div>
);
